import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  type OnInit,
  Output,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { FormsModule } from '@angular/forms';
import { SelectModule, type SelectChangeEvent } from 'primeng/select';
import {
  CurrencyCode,
  type CurrencyCodeType,
} from '@bizzdesign/sdk-knowledgegraph';

@Component({
  selector: 'bd-currency-selector',
  imports: [FormsModule, SelectModule, SharedI18nModule],
  templateUrl: './currency-selector.component.html',
  styleUrl: './currency-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencySelectorComponent implements OnInit {
  constructor() {}

  @Output() selectedCurrencyChange = new EventEmitter<CurrencyCodeType>();

  currencyOptions = Object.values(CurrencyCode);
  selectedOption = CurrencyCode.EUR;

  ngOnInit(): void {
    this.selectedCurrencyChange.emit(this.selectedOption);
  }

  onCurrencyChange(event: SelectChangeEvent) {
    if (event.value) {
      this.selectedCurrencyChange.emit(event.value);
    }
  }
}
